import * as ApiClient from '@/libs/ApiClient';
import type { AxiosResponse } from 'axios';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 集保(TDCC) TxID 回應結果
 */
export interface IGetTdccTXIDResult {
    /** 集保交易 ID */
    txID: string;
    /** 集保跳轉 URL */
    tdccRedirectUrl: string;
}

/**
 * 集保(TDCC) 取得 TxID 回應
 */
export interface IGetTdccTXIDResponse {
    /** 回應狀態 */
    status: boolean;
    /** 訊息 */
    message: string | null;
    /** 結果 */
    result: IGetTdccTXIDResult | null;
}

/**
 * 集保(TDCC) - 取得 TxID 並取得跳轉 URL（全域授權，不需指定 ItemID）
 *
 * @description 呼叫後端取得集保 TxID，產生 AuthToken，回傳跳轉 URL
 * @returns Promise<IGetTdccTXIDResponse>
 */
export async function GetTdccTXID(): Promise<IGetTdccTXIDResponse> {
    const url = RouteUrlList.API_TdccGetTXID.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return await ApiClient.post(
        url,
        {},
        config
    ).then((res: AxiosResponse<IGetTdccTXIDResponse>) => {
        return res.data;
    });
}

export default GetTdccTXID;
